import { Box, Button } from "@mui/material";

export const Unauthorized = ({
  onSignOut,
  userError,
  userTokens,
}: {
  onSignOut: any;
  userError: any;
  userTokens: any;
}) => (
  <Box sx={{ display: "flex", minHeight: "90vh", px: 5, alignItems: "center", justifyContent: "center" }}>
    <Box sx={{ mr: 4 }}>
      <Box>Unauthorized</Box>
      <Box sx={{ fontSize: 14, opacity: 0.4 }}>{userError?.message}</Box>
    </Box>
    {userTokens ? (
      <Button variant="contained" onClick={onSignOut}>
        Retry
      </Button>
    ) : null}
  </Box>
);
